import { SnackToast as Toast } from "@/utils/snackToast";

interface ISuccessMessage {
  message?: string | string[];
  componentName?: string;
  componentProps?: any;
  queue?: boolean;
  duration?: number;
}

export const showErrorMessage = (
  message?: string | string[],
  queue = true,
  color = "is-warning",
  duration = 8000,
  componentName = "",
  componentProps = {}
) => {
  const showToast = Boolean(message || componentName);
  showToast &&
    Toast.open({
      message: message,
      type: color,
      position: "is-top",
      duration,
      queue,
      componentName,
      componentProps
    });
};

export const showSuccessMessage = ({
  message,
  componentName,
  componentProps,
  queue = true,
  duration = 8000
}: ISuccessMessage) => {
  const showToast = Boolean(message || componentName);
  showToast &&
    Toast.open({
      message,
      componentName,
      componentProps,
      type: "is-success",
      position: "is-top",
      duration,
      queue
    });
};
